<script>
  import Container from '@/library/container/full-centre.svelte';
  import LgTextBlock from '@/library/content/lg-text-block.svelte';

  import Grid from '@/library/grid/basic-123.svelte';
  import Preview from '@/library/image/sm-preview.svelte';

  export let projects;

  // let layout = projects.layout;
  // let pretext = projects.content.pretext;
  let context = projects.content.context;
  // let subtext = projects.content.subtext;
  // let meta = projects.meta;
</script>

<style></style>

<section id="projects" class="bg-white py-4xl">
  <Container>

    <LgTextBlock data={context} />

    <div class="px-sm">
      <Grid>
        {#each context.items as item}
          <Preview {item} />
        {/each}
      </Grid>
    </div>

  </Container>
</section>